<template>
    <div class="container-fluid">
        <h5 :title="article.title" v-html="article.title" class="text-nowrap text-truncate"></h5>
        <div v-html="article.content"></div>
    </div>
</template>

<script>
	import axios from "axios"
	export default {
		name: "NewsDetail",
		data() {
			return {
				"article": {
					"title": "",
					"content": "",
				}
			}
		},
		methods: {
			getArticleDetail() {
				let params = {
					"params": this.$route.query
				}
				axios.get(process.env.VUE_APP_BASE_API + "/v1/article/detail", params).then(
					response => {
						this.article.content = response.data.data.content
						this.article.title = response.data.data.title
					},
					error => {
						console.log(error)
					}
				)
			}
		},
		created() {
			this.getArticleDetail()
		},
	}
</script>

<style scoped>
    h5 {
        margin-bottom: 1rem;
    }
    .container-fluid >>> img {
        width: 90%;
        height: 90%;
    }
    >>> p {
        text-align: left;
    }
</style>